// Module
var code = "<single-media-display ng-if=\"!$ctrl.mainController.sourceMedia\" media=\"$ctrl.mainController.media\"></single-media-display><multi-media-display ng-if=\"$ctrl.mainController.sourceMedia\" media=\"$ctrl.mainController.media\" source-media=\"$ctrl.mainController.sourceMedia\"></multi-media-display>";
// Exports
module.exports = code;